module.exports = __webpack_public_path__ + "files/380fb2cda7f61d4b177b2e9cc633444d.png";